import angular from 'angular';

import { TaskProcessWrapperController } from './task-process-wrapper/task-process-wrapper.controller';
import { TasksListNgController } from './tasks-list/tasks-list-ng/tasks-list-ng.controller';

angular
  .module('tasks', [])
  .controller('TaskProcessWrapperController', TaskProcessWrapperController)
  .controller('TasksListNgController', TasksListNgController);
